const dataUrl = map_object.json_path;
const dataInput = document.getElementById('gl-datas');
const storeContainer = document.getElementById('map__stores');
const mapContainer = document.getElementById('map-content');
const storeTab = document.getElementById('tab-list');
const mapTab = document.getElementById('tab-map');
const markerSize = 40;
const markers = [];
const arrayTypes = [];
const arrayCategories = [];
let group;

const variables = {};
if (dataUrl, dataInput) {
  const params = { type: !!dataInput.dataset.param ? dataInput.dataset.param : 'all' };
  variables.shortcodeTypeValue = !!dataInput.dataset.param ? dataInput.dataset.param : 'all';
  variables.shortcodeTemplateValue = !!dataInput.dataset.template ? dataInput.dataset.template.toLowerCase() : 'full';
  variables.shortcodeSearchTypeValue = !!dataInput.dataset.searchtype ? dataInput.dataset.searchtype : 'leaflet';
  variables.shortcodeSearchCountryValue = !!dataInput.dataset.searchcountry ? dataInput.dataset.searchcountry : 'fr';
  variables.shortcodeSearchLanguageValue = !!dataInput.dataset.searchlanguage ? dataInput.dataset.searchlanguage : 'fr';
  variables.shortcodeGeolocalisationValue = !!dataInput.dataset.geolocation ? dataInput.dataset.geolocation : 'true';
  variables.shortcodeFiltersValue = !!dataInput.dataset.filters ? dataInput.dataset.filters : 'true';
  variables.shortcodeFiltersHeaderText = !!dataInput.dataset.filters_header ? dataInput.dataset.filters_header : 'Filtrer les résultats';
  variables.shortcodeFiltersClearText = !!dataInput.dataset.filters_clear ? dataInput.dataset.filters_clear : 'Réinitialiser les filtres';
  variables.url = new URL(`${dataUrl}`);
  variables.params = params;
  variables.breakpoint = !!dataInput.dataset.breakpoint ? dataInput.dataset.breakpoint : '768';
  variables.storeContainer = storeContainer;
  variables.mapContainer = mapContainer;
  variables.storeTab = storeTab;
  variables.mapTab = mapTab;
  variables.primaryColor = !!dataInput.dataset.primarycolor ? dataInput.dataset.primarycolor : '#e73331';
  variables.markerSize = markerSize;
  variables.markers = markers;
  variables.arrayTypes = arrayTypes;
  variables.arrayCategories = arrayCategories;
  variables.group = group;

  // set css variables
  document.getElementById("map").style.setProperty("--primaryColor", `${variables.primaryColor}`);
  document.getElementById("map").style.setProperty("--markerSize", `${markerSize}`);
  document.getElementById("map-container").style.setProperty("--breakpoint", `${variables.breakpoint}px`);

  // Add variables to the window
  window.gl = { map_ajax_url: variables.url };
}

export { variables };
